<div class="m-subheader">
  <div class="d-flex align-items-center">
    <div class="mr-auto">
      <h3 class="m-subheader__title">
        {{ 'store-products-list.title' | transloco }}
      </h3>
    </div>
    <div>
    </div>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'store-products-list.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'store-products-list.search' | transloco }}</small>
              <form class="m-form" (ngSubmit)="applyFilters()">
                <div class="m-form__section m-form__section--first">
                  <div class="form-group m-form__group m--margin-top-0">
                    <div class="input-group">
                      <input type="text" required [(ngModel)]="params.query" name="query" class="form-control m-input" [placeholder]="'store-products-list.searchProduct' | transloco">
                      <span class="input-group-btn">
                        <button class="btn btn-outline-primary" type="submit">
                          {{ 'store-products-list.btn.search' | transloco }}
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="filter">
              <small>{{ 'store-products-list.category' | transloco }}</small>
              <hx-product-category-select [(ngModel)]="params.categoryId" [brandId]="brandId"
                                          (selectChange)="applyFilters()"></hx-product-category-select>
            </div>

            <div class="row align-content-md-end m--margin-top-20">
              <div class="col-md-5">
                <button type="button" (click)="resetFilter()" class="btn btn-outline-primary m-btn m-btn--custom m-btn--icon m--margin-bottom-30">
                  {{ 'reset.list' | transloco }}
                </button>
              </div>
            </div>
          </div>

          <app-store-products-new [id]="storeProductId" (update)="updater($event)"></app-store-products-new>

          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-bottom-30" *ngIf="list.length && !isLoading.list">
            <table class="m-datatable__table">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <span>{{ 'store-products-list.name' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'store-products-list.status' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'store-products-list.shop' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'store-products-list.category' | transloco }}</span>
                </th>
                <th class="m-datatable__cell text-right">
                  <span>{{ 'store-products-list.num' | transloco }}</span>
                </th>
                <th class="m-datatable__cell text-right">
                  <span>{{ 'store-products-list.events' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let sp of list"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even}">
                <td class="m-datatable__cell">
                  {{ sp.productInfo?.title | uiLabel }}
                </td>
                <td class="m-datatable__cell">
                  <span class="text-nowrap m-badge m-badge--wide" [ngClass]="{'m-badge--danger': !sp.forSale, 'm-badge--success': sp.forSale }">
                    {{ 'storeproduct.forSale.' + sp.forSale | transloco }}
                  </span>
                </td>
                <td class="m-datatable__cell">
                  <div>{{ sp.store?.title | uiLabel }}</div>
                  <small>{{ sp.store?.address }}</small>
                </td>
                <td class="m-datatable__cell">
                  {{ sp.category?.title | uiLabel }}
                </td>
                <td class="m-datatable__cell text-right">
                  {{ sp.amount }}
                </td>
                <td class="m-datatable__cell text-nowrap text-right" style="min-width: 102px;">
                  <a (click)="updateItem(sp)" class="btn btn-outline-primary btn-sm m-btn m-btn--icon" [title]="'store-products-list.change' | transloco ">
                    <i class="la la-edit"></i>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

          <div class="m--align-center" *ngIf="list.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
